import React from 'react'
import { TheWestSomethingWentWrong } from '../../../errors/SomethingWentWrong/TheWestSomethingWentWrong/TheWestSomethingWentWrong'
import { RouteStatus } from '@news-mono/web-common'
import { createRegisterableComponent } from '@news-mono/web-common'

export const TheWestSomethingWentWrongRegistration = createRegisterableComponent(
    'west-500-page',
    () => (
        <RouteStatus statusCode={500}>
            <TheWestSomethingWentWrong />
        </RouteStatus>
    ),
)
